import { FC } from 'react';
import KickImage from 'Reuseables/KickImage';

//Import Component
import RenderHaveAddress from "../HaveAddress/index";
import RenderNoAddress from "../NoAddress/index";
import RenderAddPickupAddress from "../AddPickupAddress/index";
import RenderSelectPickupAddress from "../SelectPickupAddress/index";
import CustomBody from "../../CustomBody/index";

// Interface
import { ComponentInterface } from "./definitions";

const Component: FC<ComponentInterface> = ({
  selectedAddress,
  process,
  fetchingAddressList,
  choosenAddress,
  data,
  backHandler,
  submitSuccess,
  fetchAddressList,
  continueHandler,
  toSelectAddress,
  toAddAddress,
  addAddressBack,
  selectAddressBack,
  addEditAddress,
  selectAddressConfirm
}) => {
  switch (process) {
    case "have-address": return (
      <RenderHaveAddress
        choosenAddress={choosenAddress}
        seletAddress={toSelectAddress}
        onBack={backHandler}
        continueAction={continueHandler}
      />
    )
    case "no-address": return (
      <RenderNoAddress
        addAddress={toAddAddress}
        onBack={backHandler}
      />
    )
    case "add-address": return (
      <RenderAddPickupAddress
        selectedAddress={selectedAddress}
        submitSuccess={submitSuccess}
        onBack={addAddressBack}
      />
    )
    case "select-address": return (
      <RenderSelectPickupAddress
        onBack={selectAddressBack}
        addEditAddress={addEditAddress}
        ListAddresses={data}
        fetchingAddressList={fetchingAddressList}
        fetchAddressList={fetchAddressList}
        confirmAction={selectAddressConfirm}
      />
    )
    default: return <div />
  }
}

export default Component;